import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box } from '@mui/material';
import { medicalConditions, surgeryOptions, orNumbers } from '../../constants/options';

const BasicInfoSection = ({ formData, handleChange, setFormData, errors }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 1: Patient & Surgery Info
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="IP NO"
            fullWidth
            name="ip_no"
            InputProps={{ readOnly: true }}
            value={formData.ip_no || ''}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="UHID NO"
            fullWidth
            name="uhid_no"
            value={formData.uhid_no || ''}
            InputProps={{ readOnly: true }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={medicalConditions}
            value={formData.diagnosis || ''}
            onChange={(_, newValue) => setFormData(prev => ({ ...prev, diagnosis: newValue }))}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Diagnosis"
                fullWidth
                required
                InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                error={!!errors.diagnosis}
                helperText={errors.diagnosis}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={surgeryOptions}
            value={formData.name_of_surgery || ''}
            onChange={(_, newValue) => setFormData(prev => ({ ...prev, name_of_surgery: newValue }))}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Name of Surgery"
                fullWidth
                required
                InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                error={!!errors.name_of_surgery}
                helperText={errors.name_of_surgery}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={orNumbers}
            value={formData.or_no || ''}
            onChange={(_, newValue) => setFormData(prev => ({ ...prev, or_no: newValue }))}
            renderInput={(params) => (
              <TextField
                {...params}
                label="OR No"
                fullWidth
                required
                InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                error={!!errors.or_no}
                helperText={errors.or_no}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BasicInfoSection;
